import { useQuery } from '@tanstack/react-query'
import { profile, isEmpty } from '@myap/ui-library'
import { getRequest, queryIsEnabled } from '../utils/fetchOperations'
import { STUDENT_ENROLLMENTS_KEY } from '../components/_common/reactquery'
import {
  STUDENT_ENROLLMENT_STATUS_YES,
  STUDENT_ENROLLMENT_STATUS_NO_OTHER,
} from '../components/scoresend/constants'

const useStudentEnrollmentsQuery = ({ studentId, hasEnrollments }) => {
  const { apiUrl } = profile()
  return useQuery({
    queryKey: [STUDENT_ENROLLMENTS_KEY],
    // staleTime: 3600000,
    staleTime: 1000,
    refetchOnWindowFocus: false,
    enabled: queryIsEnabled(!isEmpty(studentId) && hasEnrollments),
    queryFn: async ({ signal }) => {
      const studentEnrollmentsData = await getRequest({
        url: `${apiUrl}/enrollments`,
        signal,
      })
      const hasRegistrations = studentEnrollmentsData?.sections.some(
        ({ examIntent }) =>
          examIntent === STUDENT_ENROLLMENT_STATUS_YES ||
          examIntent === STUDENT_ENROLLMENT_STATUS_NO_OTHER
      )
      return { hasRegistrations, sections: studentEnrollmentsData?.sections ?? [] }
    },
  })
}

export default useStudentEnrollmentsQuery
